<template>
  <div class="center">
    <a class="button" :style="'background-color:'+color" @click="clicked">{{text}}</a>
  </div>
</template>

<script>
export default {
  props: [
    'text',
    'color'
  ],
  data: () => {
    return {

    }
  },
  methods: {
    clicked() {
      this.$emit('clicked', true);
    }
  }
};
</script>

<style scoped>
.button {
  padding: 15px 30px 15px 30px;
  background-color: orange;
  color: white;
  display: flex;
  justify-content: center;
  cursor: pointer;
  border-radius: 28px;
  margin: 0px 50px 0px 50px;
}

.button:hover {
  background-color: rgb(255, 199, 95);
}

.center{
  display:flex;
  justify-content: center;
  align-items: flex-end;
}
</style>
